import React from 'react';
import AnimatedCounter from './AnimatedCounter';

/* ==================================================================
   MetricTile
   ------------------------------------------------------------------
   The compact number block used by both dashboards - application
   progress for students, job status for recruiters. Number first,
   label under it, icon as a quiet marker rather than decoration.
   ================================================================== */

export default function MetricTile({
  value,
  label,
  hint,
  icon,
  tone = 'neutral',
  live = false,
  onClick,
  className = '',
}) {
  const TONES = {
    neutral: { color: 'var(--text-primary)', chip: 'var(--surface-2)', chipFg: 'var(--text-muted)' },
    primary: { color: 'var(--primary)', chip: 'var(--primary-light)', chipFg: 'var(--primary)' },
    success: { color: '#047857', chip: '#ECFDF5', chipFg: '#047857' },
    warning: { color: '#B45309', chip: '#FFFBEB', chipFg: '#B45309' },
    danger: { color: '#B91C1C', chip: '#FEF2F2', chipFg: '#B91C1C' },
  };
  const t = TONES[tone] || TONES.neutral;
  const Tag = onClick ? 'button' : 'div';

  /* Only a tile that actually goes somewhere responds to hover. */
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`ui-metric${onClick ? ' ui-lift ui-lift--sm' : ''} ${className}`.trim()}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: '14px 16px',
        background: 'var(--white)',
        border: '1px solid var(--border)',
        borderRadius: 12,
        textAlign: 'left',
        font: 'inherit',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 28, height: 28, borderRadius: 8, background: t.chip, color: t.chipFg,
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}
      >
        {icon}
      </span>
      <span style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
        <span style={{ fontSize: 26, fontWeight: 700, lineHeight: 1, color: t.color, letterSpacing: '-0.02em' }}>
          <AnimatedCounter value={value} />
        </span>
        {live && value > 0 && <span className="ui-live-dot" aria-label="live" />}
      </span>
      <span style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-secondary)' }}>{label}</span>
        {hint && <span style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>{hint}</span>}
      </span>
    </Tag>
  );
}
